import React from 'react';

const FAQ = () => {

    const formatText = (text, length) => {
        const [showLess, setShowLess] = React.useState(true);
        if (text.length < length) {
            return <p className="mt-1">{text}</p>;
        }
        const onClickShowMore = () => {
            setShowLess(!showLess);
        }
        return (
            <p className="mt-1">
                {showLess ? `${text.slice(0, length)}...` : text}
                <a className="cursor-pointer font-bold color-primary" onClick={() => onClickShowMore()}>
                    &nbsp;{showLess ? `keep reading` : `show less`}
                </a>
            </p>
        );
    };

    const getFAQ = (icon, question, text) => {
        return <div className="col-6 mb-3">
            <div className="d-flex">
                <div className="mr-2 pt-2">
                    <img width="80" src={icon} alt="" />
                </div>
                <div>
                    <p className="font-bold color-primary mt-0 mb-1">{question}</p>
                    <div>{formatText(text, 120)}</div>
                </div>
            </div>
        </div>
    }

    return <>
        <div className="row" >
            {getFAQ("https://res.cloudinary.com/carbonclick/image/upload/v1613084275/Enterprise/Round%20Theory%20/faq-3_enbb03.png", `How is it calculated?`, `Climate change is the greatest challenge of all time. Innovative solutions in all parts of the economy will be required, which is why the first criteria for CarbonClick's Climate Positive methodology is to only work with businesses who are pushing the limits on sustainable business practices. The intention here is to reward and highlight those who invest in sustainable initiatives. Second, with simplicity and scale in mind, we analyse existing research and perform an audit of the product's life cycle to make sure there are no standout business practices which are counter to the mission. Finally, we add a large safety margin and double the required carbon offsets to make the product climate positive. Enjoy!`)}
            {getFAQ("https://res.cloudinary.com/carbonclick/image/upload/v1613084275/Enterprise/Round%20Theory%20/faq-2_piy7an.png", `What are carbon credits?`, `A carbon credit is mechanism used to measure and support projects that fight climate change. For every tonne of CO2 that a project manages to absorb or otherwise reduce, a carbon credit is issued. Carbon credits are certified by international standards and held in registries like the Gold Standard registry (international credits) and can be purchased to reduce the carbon impact of an initiative or activity.`)}
            {getFAQ("https://res.cloudinary.com/carbonclick/image/upload/v1613084275/Enterprise/Round%20Theory%20/faq-4_ktsswk.png", `Who are CarbonClick?`, `CarbonClick is a New Zealand company that exists to reverse climate change, CarbonClick empowers businesses and their customers to tackle climate change, by making carbon offsets simple, trustworthy and cost effective. Building a happier and more sustainable future for everyone.`)}
            {getFAQ("https://res.cloudinary.com/carbonclick/image/upload/v1613084275/Enterprise/Round%20Theory%20/Rt-faq1_ocrgju.png", `Where does the money go?`, `The money paid to CarbonClick for carbon credits goes towards certified carbon offset projects that have met the highest standards. The funds are distributed amongst carbon offset suppliers carrying out the projects and CarbonClick takes a margin on the carbon credits for sourcing projects, quality assurance, administration and transaction fees.`)}
        </div>
    </>
}

export default FAQ;
